import { ColumnDef } from '@tanstack/react-table';
import { ThemeExposure } from '@toggle/toggle';
import { TFunction } from 'i18next';
import React from 'react';

import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

import { TopRankIcon } from '../../../top-rank-icon/TopRankIcon';
import * as S from '../ThemeExposureTable.styles';

export const RANK_COLUMN_ID = 'rank';
const THEME_COLUMN_ID = 'theme';
const DESCRIPTION_COLUMN_ID = 'description';

export const getColumns = ({
  t,
}: {
  t: TFunction;
}): ColumnDef<ThemeExposure>[] => [
  {
    id: RANK_COLUMN_ID,
    header: t('widget:assetOverview.knowledgeGraph.themeExposure.rank'),
    cell: props => {
      const { original } = props.row;
      return (
        <S.RankWrapper>
          <TopRankIcon rank={original.relationship.rank} />
        </S.RankWrapper>
      );
    },
  },
  {
    id: THEME_COLUMN_ID,
    header: t(
      'widget:assetOverview.knowledgeGraph.themeExposure.investmentTheme'
    ),
    cell: props => (
      <S.ThemeWrapper>
        <S.StyledLogoIconWrapper>
          <ThemeLogoIcon
            name={props.row.original.theme.name}
            logo_url={props.row.original.theme.logo_url}
            isCondensed={false}
            fallbackIcon={
              <S.LogoWrapper>
                {props.row.original.theme.name.charAt(0)}
              </S.LogoWrapper>
            }
          />
        </S.StyledLogoIconWrapper>
        {props.row.original.theme.name}
      </S.ThemeWrapper>
    ),
  },
  {
    id: DESCRIPTION_COLUMN_ID,
    header: t('widget:assetOverview.knowledgeGraph.themeExposure.description'),
    cell: props => {
      return (
        <S.DescriptionWrapper>
          {props.row.original.relationship.description}
        </S.DescriptionWrapper>
      );
    },
  },
];
